"use client";

import React from "react";

export function AuthPanel({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.06] shadow-[0_25px_80px_-40px_rgba(0,0,0,0.9)]">
      <div className="absolute inset-0 bg-gradient-to-b from-white/[0.10] to-transparent" />
      <div className="relative p-6 md:p-7">{children}</div>
    </div>
  );
}

